import {
  Address,
  AloftArea,
  AloftPrice,
  ConstellationOneListing,
  LatitudeLongitude,
  getC1MonthFromDateString,
  getLotAreaInSqft,
  isDefined,
  orUndefined,
  syntaxFNMA,
} from '@aloft/toolkit-shared';

import { proximityMiles } from '../../utils/proximityMiles.ts';
import { VacantLandSalesProperty } from './types.ts';

export const constellation1ListingsToVacantLandSalesProps = (
  listings: ConstellationOneListing[],
  subjectCoordinates?: LatitudeLongitude,
): VacantLandSalesProperty[] => {
  const vacantLandSales = listings
    .map((listing) => {
      const {
        Latitude: latitude,
        Longitude: longitude,
        ListingId: listingID,
        UnparsedAddress,
      } = listing;

      const saleMonth = getC1MonthFromDateString(listing.CloseDate);
      const saleDate = orUndefined(syntaxFNMA.isoMonthToAloftDate)(saleMonth);
      if (!listingID || !saleMonth || !UnparsedAddress) return undefined;

      const address: Address = {
        CityName: listing.City,
        StateCode: listing.StateOrProvince,
        PostalCode: listing.PostalCode,
        AddressLineText: UnparsedAddress,
      };

      const listingCoordinates =
        isDefined(latitude) && isDefined(longitude) ? { longitude, latitude } : undefined;

      const distanceToSubject =
        subjectCoordinates && listingCoordinates
          ? Number(proximityMiles(subjectCoordinates, listingCoordinates)!.toFixed(2))
          : undefined;

      if (!distanceToSubject) return undefined;

      return {
        id: listingID,
        address,
        gla: AloftArea.fromNumber(listing.LivingArea, 'sqft'),
        lotSize: getLotAreaInSqft(listing),
        saleDate,
        salePrice: AloftPrice.fromDollarLike(listing.ClosePrice),
        distanceToSubject,
        latitude,
        longitude,
        listingID,
      };
    })
    .filter(isDefined)
    .sort((a, b) => a.distanceToSubject - b.distanceToSubject);

  return vacantLandSales;
};
